// components
import { PopoverButton } from '@newo/ui-kit';
// icons
import { Plus } from 'lucide-react';
// utils
import type {
    TAgentPersonaToLink,
    TPersonaData,
    TPersona
} from '@newo/api/gateway';
import { useState } from 'react';
import PersonasAutocomplete from '@/modules/Personas/components/PersonasAutocomplete';
import PersonaForm from '@/modules/Personas/components/PersonaForm';

interface PersonaSelectProps {
    label?: string;
    placeholder?: string;
    persona?: TAgentPersonaToLink | null;
    onSelect: (personaId?: string) => void;
}

const PersonaSelect = ({ persona, onSelect }: PersonaSelectProps) => {
    const [personaName, setPersonaName] = useState(persona?.name);

    const handleSelect = (p?: TPersona) => {
        onSelect(p?.id);
    };

    const handleSubmit = (personaId: string, data: TPersonaData) => {
        onSelect(personaId);
        setPersonaName(data.name);
    };

    return (
        <div className="flex gap-2 items-center">
            <PersonasAutocomplete
                className="flex-1"
                label="Select Persona"
                params={{ is_linked_to_agent: false }}
                personaName={personaName}
                placeholder="Start typing..."
                onSelect={handleSelect}
            />

            <PopoverButton
                className="leading-none mt-6"
                title="Add Flow"
                trigger={<Plus />}
            >
                {(close) => (
                    <PersonaForm onClose={close} onSubmit={handleSubmit} />
                )}
            </PopoverButton>
        </div>
    );
};

export default PersonaSelect;
